class DetectTab {
    constructor() {
        this.isKeyboard = false;
        this.bindEvents();
    }

    bindEvents() {
        document.addEventListener('keydown', event => {
                if (event.key === 'Tab') {
                    this.setKeyboard()
                }
            }
        );
        document.addEventListener('click', () => this.setMouse());
    }

    setKeyboard() {
        if (!this.isKeyboard) {
            document.querySelector('body').classList.add('keyboard-input');
            this.isKeyboard = true;
        }
    }

    setMouse() {
        if (this.isKeyboard) {
            document.querySelector('body').classList.remove('keyboard-input');
            this.isKeyboard = false;
        }
    }

}

document.addEventListener('DOMContentLoaded', () => {
    new DetectTab;
});